/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ガス作業委託情報
 */
export interface Szoa308aResponseGasAceptSearchResultDtoGasWorkConsignInfo {
    /**
     * 作業予定日付：日付(yyyyMMdd)
     */
    workScdDate?: string;
    /**
     * 作業予定時間帯区分コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C000370」のユーザコードを設定
     */
    workTimezkbnCode?: string;
    /**
     * 作業予定時間帯区分名称：全半角混在
     */
    workTimezkbnMeisho?: string;
    /**
     * 作業指定時刻（ＦＲＯＭ）：時刻(HHmm)
     */
    workSteitimeFrom?: string;
    /**
     * 作業指定時刻（ＴＯ）：時刻(HHmm)
     */
    workSteitimeTo?: string;
}

